import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
    class: "modal-something-wrong",
    "bold-title": true,
    acceptTheme: "primary",
    rejectTheme: "return",
    titleText: "Trailer Does Not Match",
    subtitleText: _ctx.subtitleText,
    acceptText: "Go Back",
    onAccept: _ctx.goBack,
    rejectText: "New Scan",
    onReject: _ctx.navigateToEnterTrailer,
    includeReturnDeepLink: false
  }, null, 8, ["subtitleText", "onAccept", "onReject"]))
}